// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".6e4aee6d2edf8143f4fb1d272e8f2905.js";
};